const _gallery = {
	withAnchor: false,
	withLightbox: false,
	withInfo: false,
	layout: 'horizontal',
	items: [
		{
			id: 1,
			info: {
				title: 'Title 1',
				subtitle: 'Subtitle 1',
				description: 'Description large text 1'
			},
			image: 'OnFocus-Media_galeria_sm_01.jpg',
			image_highres: 'OnFocus-Media_galeria_01.jpg',
			link: ''
		},
		{
			id: 2,
			info: {
				title: 'Title 2',
				subtitle: 'Subtitle 2',
				description: 'Description large text 2'
			},
			image: 'OnFocus-Media_galeria_sm_02.jpg',
			image_highres: 'OnFocus-Media_galeria_02.jpg',
			link: ''
		},
		{
			id: 3,
			info: {
				title: 'Title 3',
				subtitle: 'Subtitle 3',
				description: 'Description large text 3'
			},
			image: 'OnFocus-Media_galeria_sm_03.jpg',
			image_highres: 'OnFocus-Media_galeria_03.jpg',
			link: ''
		},
		{
			id: 4,
			info: {
				title: 'Title 4',
				subtitle: 'Subtitle 4',
				description: 'Description large text 4'
			},
			image: 'OnFocus-Media_galeria_sm_04.jpg',
			image_highres: 'OnFocus-Media_galeria_04.jpg',
			link: ''
		},
		{
			id: 5,
			info: {
				title: 'Title 5',
				subtitle: 'Subtitle 5',
				description: 'Description large text 5'
			},
			image: 'OnFocus-Media_galeria_sm_05.jpg',
			image_highres: 'OnFocus-Media_galeria_05.jpg',
			link: ''
		},
		{
			id: 6,
			info: {
				title: 'Title 6',
				subtitle: 'Subtitle 6',
				description: 'Description large text 6'
			},
			image: 'OnFocus-Media_galeria_sm_06.jpg',
			image_highres: 'OnFocus-Media_galeria_06.jpg',
			link: ''
		},
		{
			id: 7,
			info: {
				title: 'Title 7',
				subtitle: 'Subtitle 7',
				description: 'Description large text 7'
			},
			image: 'OnFocus-Media_galeria_sm_07.jpg',
			image_highres: 'OnFocus-Media_galeria_07.jpg',
			link: ''
		},
		{
			id: 8,
			info: {
				title: 'Title 8',
				subtitle: 'Subtitle 8',
				description: 'Description large text 8'
			},
			image: 'OnFocus-Media_galeria_sm_08.jpg',
			image_highres: 'OnFocus-Media_galeria_08.jpg',
			link: ''
		},
		{
			id: 9,
			info: {
				title: 'Title 9',
				subtitle: 'Subtitle 9',
				description: 'Description large text 9'
			},
			image: 'OnFocus-Media_galeria_sm_09.jpg',
			image_highres: 'OnFocus-Media_galeria_09.jpg',
			link: ''
		},
		{
			id: 10,
			info: {
				title: 'Title 10',
				subtitle: 'Subtitle 10',
				description: 'Description large text 10'
			},
			image: 'OnFocus-Media_galeria_sm_10.jpg',
			image_highres: 'OnFocus-Media_galeria_10.jpg',
			link: ''
		},
		{
			id: 11,
			info: {
				title: 'Title 11',
				subtitle: 'Subtitle 11',
				description: 'Description large text 11'
			},
			image: 'OnFocus-Media_galeria_sm_11.jpg',
			image_highres: 'OnFocus-Media_galeria_11.jpg',
			link: ''
		},
		{
			id: 12,
			info: {
				title: 'Title 12',
				subtitle: 'Subtitle 12',
				description: 'Description large text 12'
			},
			image: 'OnFocus-Media_galeria_sm_12.jpg',
			image_highres: 'OnFocus-Media_galeria_12.jpg',
			link: ''
		}
	]
}

export default {
	getData(callback) {
		callback(_gallery)
	}
}
